//basic
import React from 'react'
import { toJS } from 'mobx'
import { observer, inject } from 'mobx-react'

//api
import { api } from '../../../../functions/api'

//custom components

//material-ui
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  CircularProgress,
} from '@material-ui/core'
import CustomInput from '../../../../components/basic/input'
import SelectSearch from '../../../../components/basic/SelectSearch/SelectSearch'
import CustomButton from '../../../../components/basic/CustomButton'

//style

@inject('translate')
@inject('internal')
@observer
export default class AddToXmlExports extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: true,
      loadingBtn: false,
      data: [],
      selected: [],
      title: '',
      xmlExports: [],
      availableXmlExports: this.formatItems(this.props.xmlExports),
      // availableXmlExports: [],
      contentHeight: 'initial'
    }
  }
  
  formatItems(items) {
    return items.map(item => ({
      value: item.id,
      label: item.title,
    }))
  }
  
  save = () => {
    return api({
      method: 'put',
      url: `products/pair-xml-exports`,
      authorization: this.props.internal.user.access_token,
      params: {
        product_ids: toJS(this.props.internal.checkedRows),
        xml_export_ids: this.state.xmlExports.map(item => item.value),
      },
    }).then(response => {
      if (true === response.success) {
        this.props.internal.setSnackbar(response.data.message, true)
        this.props.onClose();
        this.props.closeDialog(true);
        return Promise.resolve()
      }
      
      this.props.internal.setSnackbar(response.data.message, true, true)
      
      return Promise.reject(response.error)
    })
    
  }
  
  stretchContent = () => {
    this.setState({contentHeight: 200 })
  }
  
  resetContent = () => {
    this.setState({contentHeight: 'initial'})
  }
  
  render() {
    return (
      <Dialog
        open={this.props.open}
        onClose={() => this.props.onClose(false)}
        aria-labelledby="form-dialog-title"
        scroll={'body'}
      >
        <DialogTitle id="form-dialog-title">{this.props.translate.i18n.MODULES.PRODUCTS.PAIR_XML_EXPORTS}</DialogTitle>
        <DialogContent style={{minHeight: this.state.contentHeight}}>
          <SelectSearch
            onMenuOpen={() => this.stretchContent()}
            onMenuClose={() => this.resetContent()}
            className={'mt-10'}
            options={this.state.availableXmlExports}
            value={this.state.xmlExports}
            label={this.props.translate.i18n.GLOBAL.MENU.LISTS_XML_EXPORTS}
            onChange={xmlExports => this.setState({ xmlExports })}
            isMulti
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => this.props.onClose(false)} className={'gray-text'}>
            {this.props.translate.i18n.GLOBAL.BUTTONS.CANCEL}
          </Button>
          <CustomButton
            progressBar={this.state.loadingBtn}
            onClick={this.save}
            mystyle={'btn-white-bg'}
            title={this.props.translate.i18n.GLOBAL.BUTTONS.SAVE}
            justText
          />
        </DialogActions>
      </Dialog>
    )
  }
}



// WEBPACK FOOTER //
// ./src/screens/products/list/AddToXmlExports/index.js